import React from 'react';
import { RenderElementProps } from 'slate-react';
import styled from 'styled-components';
import {
  SpanElement,
  type HeadingThreeElement,
} from '~/components/organism/PluginsEditor/types';
import ELEMENTS from '~/components/organism/PluginsEditor/components/elements/elementsEnum';
import serializeHeading from '../../../utils/serialize/serializeHeading';

export type Props = RenderElementProps & {
  element: SpanElement;
};

const HeadingThree: React.FCC<Props> = ({ attributes, element, children }) => (
  <Container {...attributes} {...element.attributes}>
    {children}
  </Container>
);

const Container = styled.h3<{}>`
  margin: 0;
`;

export default {
  renderComponent: props => <HeadingThree {...props} />,
  nodeName: 'H3',
  deserialize: () => ({
    type: ELEMENTS.H3,
  }),
  serialize: (node: HeadingThreeElement, children) =>
    serializeHeading('h3', children),
};
